'use strict'

// helper method returns a crop rectangle for a given image and target
// width/height

module.exports = function getCrop(image, width, height) {
    // defaults
    // use whole image by default
    var crop = {
        x: 0,
        y: 0,
        w: image.width,
        h: image.height,
    }

    var crop_ratio = width / height
    var image_ratio = image.width / image.height

    if (image_ratio < crop_ratio) {
        // portrait, square, square-ish images
        crop.w = image.width
        crop.h = Math.floor(image.width / crop_ratio)
        // get center of highlight from top (y + (h / 2))
        var top = image.highlight.y + (image.highlight.h / 2)
        // calculate strict y (t - (h / 2))
        crop.y = top - (crop.h / 2)
        // adjust for image edge
        crop.y = Math.floor(
            Math.max(0, Math.min(crop.y, image.height - crop.h))
        )
    } else {
        crop.h = image.height
        crop.w = Math.floor(image.height * crop_ratio)
        // get center of highlight from left (x + (w / 2))
        var left = image.highlight.x + (image.highlight.w / 2)
        // calculate strict x (l - (w / 2))
        crop.x = left - (crop.w / 2)
        // adjust for image edge
        crop.x = Math.floor(Math.max(0, Math.min(crop.x, image.width - crop.w)))
    }

    return crop
}
